import documentStep from './DocumentStep';
import keydataStep from './KeyDataStep';
import summaryStep from './SummaryStep';

export default [keydataStep, documentStep, summaryStep];
